// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Rusha from 'rusha';

export const hash: (body: string) => string = (body: string) =>
  Rusha.createHash()
    .update(body.substring(0, 100) + 'saltsaltsalt')
    .digest('hex');
